import { render, staticRenderFns } from "./BookOfEinikis.vue?vue&type=template&id=c4c334cc&"
import script from "./BookOfEinikis.vue?vue&type=script&lang=js&"
export * from "./BookOfEinikis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports